import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import i18n from './i18n';
import { useTheme } from '../../contexts/ThemeContext';
import { getLangFromUrl, normalizeAppLanguage } from './languageConstants';
import { applyAppLanguage } from './languageUtils';

/**
 * URL ?lang=ko|en 변경 시 i18n·쿠키·theme locale 동기화
 */
export default function LanguageRouteSync() {
  const { search } = useLocation();
  const themeContext = useTheme();
  const setThemeLocale = themeContext?.set;

  /** 마운트 시 i18n 초기값 → theme locale·쿠키 정합 */
  useEffect(() => {
    const urlLang = getLangFromUrl(search);
    const lang = urlLang || normalizeAppLanguage(i18n.language) || 'ko';
    applyAppLanguage(lang, {
      onThemeLocale: (locale) => setThemeLocale?.('locale', locale, false),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const urlLang = getLangFromUrl(search);
    if (!urlLang) return;
    applyAppLanguage(urlLang, {
      onThemeLocale: (locale) => setThemeLocale?.('locale', locale, false),
    });
  }, [search, setThemeLocale]);

  return null;
}
